module.exports = __webpack_public_path__ + "media/giftcards/GC-Hero-f54e35d8.png";